/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';
import { filter } from 'lodash';

export function computeFetchId() {
    return uuidv4();
}

export default declareEntity({
    name: "Fetches",
    graphQL: "Fetch",
    entity: 'fetches',
    storageType: 'silo',
    description: "Fetches of source",
    userEditable: false,
    defaultOrder: [['updatedAt', 'desc']],
    optimizeReading: true,
    fields: (types) => { return {
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            required: true
        },
        realChannelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            required: true,
            userEditable: false,
        },
        sourceDef: {
            name: "SourceDef",
            type: "relation",
            to: () => types['sourceDefs'],
            required: true,
            relativeTo: ['realChannelDef'],
        },
        actionDef: {
            name: "Action",
            type: "relation",
            to: () => types['actionDefs'],
            relativeTo: ['realChannelDef'],
        },
        flowInvocation: {
            name: "Flow Invocation",
            type: "relation",
            to: () => types['flowInvocations'],
            relativeTo: ['flow'],
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
        },
        flowStepDef: {
            name: "Flow Step Definition",
            type: "relation",
            to: () => types['flowStepDefs'],
            relativeTo: ['flowDef'],
        },
        name: {
            name: "Name",
            type: "string",
            translatable: true,
            filterable: true,
        },
        url: {
            name: "URL",
            type: "string",
        },
        method: {
            name: "Method",
            type: "string",
        },
        success: {
            name: "Success",
            type: "boolean",
            filterable: true,
        },
        ignoredError: {
            name: "Ignored error",
            type: "boolean",
            filterable: true,
        },
        errorType: {
            name: "Error Type",
            type: "int",
        },
        error: {
            name: "Error",
            type: "string",
        },
        id: {
            name: "Fetch ID",
            type: "id",
            defaultValue: computeFetchId,
            primaryKey: true,
            required: true
        },
        request: {
            name: "Request",
            type: "object",
            defaultValue: {},
            userEditable: false,
            offload: true,
            filterable: true,
        },
        delay: {
            name: "Delay due to rate limiting (ms)",
            type: "int",
            defaultValue: 0,
        },
        duration: {
            name: "Request duration (ms)",
            type: "int",
            defaultValue: 0,
        },
        dataLength: {
            name: "Data Length",
            type: "int",
        },
        server: {
            name: "Requested by server",
            type: "string",
        },
        pagerState: {
            name: "Paging state",
            type: "object",
            defaultValue: {},
            userEditable: false,
        },
        data: {
            name: "Data",
            type: "binary",
            userEditable: false,
            offload: true,
            filterable: true,
        },
        dataPreview: {
            name: "Data preview",
            type: "binary",
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getDataPreview",
        },
        channelErrorDef: {
            name: "Channel Error Definition",
            type: "relation",
            to: () => types['channelErrorDefs'],
            filterable: true,
        },
        expiresAt: {
            name: "Expires At",
            type: "datetime",
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            filterable: true,
            userEditable: false,
        },
        user: {
            name: "User",
            type: "relation",
            to: () => types['users'],
            defaultValue: (user) => {
                return user['id'];
            },
            parent: true,
            hiddenCreate: true,
        },
	}; },
    relations: (types) => { return {
        channelErrorDefs: {
            type: 'oneToMany',
            to: types['channelErrorDefs'],
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getMatchingErrors",
        },
    }; }
});
